<template functional>
  <div class="costs-item">
    <img class="costs-item__image" :src="props.image" />
    <h3 class="costs-item__title">
      {{ props.title }}
    </h3>
    <p class="costs-item__content">
      {{ props.content }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'CostsItem',
  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.costs-item {
  display: grid;
  grid-template-rows: min-content;
  justify-items: center;
  align-items: center;
  grid-row-gap: $sp-s;

  &__title {
    @include font('DS-300');
    font-weight: bold;
    text-align: center;
  }

  &__content {
    @include font('DS-100');
    text-align: center;
  }
}
</style>
